import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {graphql, compose} from 'react-apollo';
import {withApollo} from 'react-apollo';
import {autobind} from 'core-decorators';
import classNames from 'classnames';
import {
    parseQueryString,
    removeEmptyValues,
    addQueryParams,
    getCurrentPage,
    getPageFromQS,
    getMaxPage,
} from 'core/utils';
import userQuery from 'graphql/queries/user.gql';
import categoriesQuery from 'graphql/queries/categories.gql';
import merchandisingQuery from 'graphql/queries/merchandising.gql';
import {isSessionSupervisor} from 'core/utils';
import Spinner from 'components/spinner';
import SectionBanner from 'components/section-banner';
import {Input, Toggle} from 'components/forms';
import Button from 'components/button';
import ProductGrid from 'components/product-grid';
import Banners from 'components/banners';
import Pagination from 'components/pagination';
import styles from './styles.css';

@compose(graphql(userQuery, {name: 'userData'}))
@graphql(categoriesQuery, {name: 'categories'})

@withApollo
@autobind
export default class Merchandising extends Component {
    static contextTypes = {
        router: PropTypes.object,
    };

    state = {
        search: '',
        filtersVisible: false, // Used for mobile toggling
        loading: false,
        products: {},
        filterCategoriesVisible: false,
        filterTagsVisible: false,
        filterOrderingVisible: false,
        categories: [],
        tags: [],
        ordering: [],
        hasFilters: false,
    };

    pageSize = 15;

    componentDidMount() {
        this.load(this.props.location.search);
    }

    componentWillReceiveProps(nextProps) {
        this.load(nextProps.location.search);
    }

    async load(locationProps) {
        const params = parseQueryString(locationProps) || {};
        const page = params.page ? params.page : 0;
        this.setState({loading: true});
        const filterCategories = Array.isArray(params.category) ? params.category.map(category => category) : [params.category];
        const filterTag = Array.isArray(params.tag) ? params.tag.map(tag => tag) : [params.tag];
        const filterOrdering = Array.isArray(params.ordering) ? params.ordering.map(ordering => ordering) : [params.ordering];
        const response = await this.makeRequest({...params, page, pageSize: this.pageSize});
        await this.setState({
            products: response.data.products,
            loading: false,
            ordering: this.getOrderOptions().map(order => ({
                value: order.value,
                label: order.label,
                cheked: filterOrdering.find(filterOrdering => filterOrdering == order.value),
            })),
            categories: this.props.categories.categories.map(category => ({
                value: category.id,
                label: category.name,
                cheked: filterCategories.find(filterCategory => filterCategory == category.id),

            })),
            tags: this.getTagOptions().map(tag => ({
                value: tag.value,
                label: tag.label,
                cheked: filterTag.find(filterTag => filterTag == tag.value),
            })),
        });
    }

    handleFilterChange(params, field, resetPage = false) {
        const {history} = this.context.router;
        const oldParams = parseQueryString(this.props.location.search) || {};

        if (oldParams[field] && params[field]) {
            const oldParamIndex = oldParams[field].indexOf(params[field][0]);
            if (oldParamIndex > -1) {
                Array.isArray(oldParams[field]) ? oldParams[field].splice(oldParamIndex, 1) : oldParams[field] = '';
                params[field] = oldParams[field];
            } else {
                params[field].push(oldParams[field]);
                params[field] = params[field].reduce((a, b) => a.concat(b), []);
                params[field] = params[field].filter((item, pos) => params[field].indexOf(item) == pos);
            }
        }
        const page = resetPage ? 0 : getPageFromQS(oldParams, params);
        addQueryParams({...params, page}, history, this.props.location);
    }

    handleKeyPress(params) {
        this.setState({search: params.query});
        clearTimeout(this.timeout);
        this.timeout = setTimeout(
            () => this.handleFilterChange(params),
            2000,
        );
    }

    async makeRequest(params) {
        const options = removeEmptyValues(params);
        if (options.tag || options.category || options.ordering) {
            this.setState({hasFilters: true});
        } else {
            this.setState({hasFilters: false});
        }
        const response = await this.props.client.query({
            fetchPolicy: 'network-only',
            query: merchandisingQuery,
            variables: {
                options: {...options, pageSize: this.pageSize},
            },
        });
        return response;
    }

    getTagOptions() {
        const {user} = this.props.userData;
        const options = [{value: 'new', label: 'Nuevos'}, {value: 'withStock', label: 'Con stock'}, {value: 'preOrder', label: 'A reservar'}];
        if (isSessionSupervisor(user)) options.push({value: 'withoutStock', label: 'Sin stock'});
        if (user.permissions.enableRestrictedProducts) options.push({value: 'restricted', label: 'Restringidos'});
        return options;
    }

    getOrderOptions() {
        return [
            {value: '-price', label: 'Ordenar por mayor precio'},
            {value: 'price', label: 'Ordenar por menor precio'},
            {value: '-is_new', label: 'Ordenar por novedad'},
        ];
    }

    handleMobileFiltersToggle() {
        this.setState({filtersVisible: !this.state.filtersVisible});
    }

    handleFiltersToggle(filter) {
        if (filter == 'categories') {
            this.setState({filterCategoriesVisible: !this.state.filterCategoriesVisible});
        }
        if (filter == 'tags') {
            this.setState({filterTagsVisible: !this.state.filterTagsVisible});
        }
        if (filter == 'ordering') {
            this.setState({filterOrderingVisible: !this.state.filterOrderingVisible});
        }
    }

    handlePreviousPage(page) {
        return () => {
            if (page >= 0) this.handleFilterChange({page: page - 1});
        };
    }

    handleNextPage(page, maxPage) {
        return () => {
            if (page <= maxPage) this.handleFilterChange({page: page + 1});
        };
    }

    handlePageClick(number) {
        this.handleFilterChange({page: number});
    }

    render() {
        if (this.state.loading) return <Spinner />;
        const products = Object.keys(this.state.products).length ? this.state.products.items : [];
        const maxPage = getMaxPage(this.state.products.count, this.pageSize);
        const page = getCurrentPage(this.props.location);

        return (
            <div className={styles.root}>
                <SectionBanner />
                <div className={styles.tools}>
                    <Button
                        type='button'
                        className={styles.filtersToggle}
                        theme={this.state.filtersVisible ? 'gray' : 'yellow'}
                        onClick={this.handleMobileFiltersToggle}>
                        { this.state.filtersVisible ? 
                            'CONTRAER FILTROS' : this.state.hasFilters ? 'EDITAR FILTROS' : 'APLICAR FILTROS'
                        }
                    </Button>
                    <div className={classNames(styles.filters, {[styles.hidden]: !this.state.filtersVisible})}>
                        <Input
                            type='text'
                            value={this.state.search}
                            onChange={(value) => this.handleKeyPress({query: value, page: 0})}
                            placeholder='Buscar'
                            search
                        />
                        <div className={styles.toggle} onClick={() => this.handleFiltersToggle('categories')}>
                            {this.state.filterCategoriesVisible
                                ? <i className='material-icons'>keyboard_arrow_up</i>
                                : <i className='material-icons'>keyboard_arrow_down</i>
                            }
                            <p>Categoría</p>
                        </div>
                        {this.state.filterCategoriesVisible && this.state.categories.map(category => (
                            <Toggle
                                key={category.value}
                                type='checkbox'
                                value={category.cheked}
                                label={category.label}
                                onChange={(value) => this.handleFilterChange({category: [String(category.value)]}, 'category', true)}
                            />
                        ))}
                        <div className={styles.toggle} onClick={() => this.handleFiltersToggle('tags')}>
                            {this.state.filterTagsVisible
                                ? <i className='material-icons'>keyboard_arrow_up</i>
                                : <i className='material-icons'>keyboard_arrow_down</i>
                            }
                            <p>Etiqueta</p>
                        </div>
                        {this.state.filterTagsVisible && this.state.tags.map((tag, index) => (
                            <Toggle
                                key={index}
                                type='checkbox'
                                value={tag.cheked}
                                label={tag.label}
                                onChange={(value) => this.handleFilterChange({tag: [String(tag.value)]}, 'tag', true)}
                            />
                        ))}
                        <div className={styles.toggle} onClick={() => this.handleFiltersToggle('ordering')}>
                            {this.state.filterOrderingVisible
                                ? <i className='material-icons'>keyboard_arrow_up</i>
                                : <i className='material-icons'>keyboard_arrow_down</i>
                            }
                            <p>Orden</p>
                        </div>
                        {this.state.filterOrderingVisible && this.state.ordering.map((order, index) => (
                            <Toggle
                                key={index}
                                type='checkbox'
                                value={order.cheked}
                                label={order.label}
                                onChange={(value) => this.handleFilterChange({ordering: [String(order.value)]}, 'ordering', true)}
                            />
                        ))}
                    </div>
                    {products.length > 0 && <ProductGrid products={products} />}
                </div>
                {maxPage > 0 && (
                    <Pagination
                        maxPage={maxPage}
                        active={page}
                        handlePreviousPage={this.handlePreviousPage(page)}
                        handleNextPage={this.handleNextPage(page, maxPage)}
                        handlePageClick={this.handlePageClick}
                    />
                )}
                <Banners noCredit />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./views/merchandising/index.js